/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Save_LayoutInputs */

const cs_messages_save_layout = /** @type {(inputs: Messages_Save_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uložit rozložení`)
};

const en_messages_save_layout = /** @type {(inputs: Messages_Save_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save layout`)
};

/**
* | output |
* | --- |
* | "Save layout" |
*
* @param {Messages_Save_LayoutInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_save_layout = /** @type {((inputs?: Messages_Save_LayoutInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Save_LayoutInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_save_layout(inputs)
	return cs_messages_save_layout(inputs)
});